import { useEffect, useRef, useState } from 'react';

const parse = (text) =>
  text.includes('/') || /^(19|20)\d{2}$/.test(text)
    ? null
    : text.match(/^(\D*)(\d+)(.*)$/);

export default function CountUp({ value, duration = 1800, className = '' }) {
  const text = String(value);
  const m = parse(text);
  const ref = useRef(null);
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!m || !ref.current) return undefined;
    const target = Number(m[2]);
    const small = target <= 10;
    const total = small ? 350 * target + 300 : duration;
    let raf;

    const run = () => {
      const start = performance.now();
      const tick = (now) => {
        const p = Math.min((now - start) / total, 1);
        const eased = small ? p : 1 - Math.pow(1 - p, 3);
        setN(Math.round(target * eased));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    };

    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting) {
          io.disconnect();
          run();
        }
      },
      { threshold: 0.3 }
    );
    io.observe(ref.current);

    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [text, duration]);

  if (!m) return <span className={className}>{text}</span>;
  return (
    <span ref={ref} className={className}>
      {m[1]}{n}{m[3]}
    </span>
  );
}